import { render, staticRenderFns } from "./NotCollectedDetailModal.vue?vue&type=template&id=bf78eddc&scoped=true"
import script from "./NotCollectedDetailModal.vue?vue&type=script&lang=js"
export * from "./NotCollectedDetailModal.vue?vue&type=script&lang=js"
import style0 from "./NotCollectedDetailModal.vue?vue&type=style&index=0&id=bf78eddc&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf78eddc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf78eddc')) {
      api.createRecord('bf78eddc', component.options)
    } else {
      api.reload('bf78eddc', component.options)
    }
    module.hot.accept("./NotCollectedDetailModal.vue?vue&type=template&id=bf78eddc&scoped=true", function () {
      api.rerender('bf78eddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CommonPage/NotCollectedBasemap/components/NotCollectedDetailModal.vue"
export default component.exports